import {TabPanelProps} from '../Config/TabPanel.types';
import {Box} from '../../../ui-library';
import React from 'react';

const TabPanelView = (props: TabPanelProps) => {
    const { children, value, index } = props;


    return (
        <>
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </>
    );
};

export default TabPanelView;
